import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthLayoutRoutes } from './auth-layout.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LandingPageComponent } from 'src/app/pages/landing-page/landing-page/landing-page.component';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { ServicesComponent } from 'src/app/pages/landing-page/pages/services/services.component';
import { AboutComponent } from 'src/app/pages/landing-page/pages/about/about.component';
import { DescriptionComponent } from 'src/app/pages/landing-page/pages/description/description.component';
import { PricingComponent } from 'src/app/pages/landing-page/pages/pricing/pricing.component';
import { GetstartComponent } from 'src/app/pages/landing-page/pages/getstart/getstart.component';
import { BlogComponent } from 'src/app/pages/landing-page/pages/blog/blog.component';
import { ContactComponent } from 'src/app/pages/landing-page/pages/contact/contact.component';
import { TestiComponent } from 'src/app/pages/landing-page/pages/testi/testi.component';
import { ClientComponent } from 'src/app/pages/landing-page/pages/client/client.component';
import { FeatureComponent } from 'src/app/pages/landing-page/pages/feature/feature.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { ChangePasswordComponent } from 'src/app/pages/change-password/change-password.component';
import { ForgotPassComponent } from 'src/app/pages/forgot-pass/forgot-pass.component';
import { RegistroClienteComponent } from 'src/app/pages/registro-cliente/registro-cliente.component';
import { DataTablesModule } from 'angular-datatables';
import { DxLoadPanelModule } from 'devextreme-angular';
import { ValidacionIdentidadComponent } from 'src/app/pages/validacion-identidad/validacion-identidad.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';


@NgModule({
  declarations: [
    LandingPageComponent,
    LoginComponent,
    ServicesComponent,
    AboutComponent, 
    DescriptionComponent, 
    PricingComponent,
    GetstartComponent, 
    BlogComponent, 
    ContactComponent, 
    TestiComponent,
    ClientComponent,
    FeatureComponent,
    ChangePasswordComponent,
    ForgotPassComponent,
    RegistroClienteComponent,
    ValidacionIdentidadComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(AuthLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    DataTablesModule,
    DxLoadPanelModule,
    PdfViewerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthLayoutModule { }
